import { assertInInjectionContext, inject } from '@angular/core';
import { NotificationStackService } from './notification/notification-stack.service';

export interface InjectToast {
	open: typeof NotificationStackService.prototype.open;
	closeAll: typeof NotificationStackService.prototype.closeAll;
	hasId: typeof NotificationStackService.prototype.hasId;
	exists: typeof NotificationStackService.prototype.exists;
	closeBy: typeof NotificationStackService.prototype.closeBy;
}

export const injectToast = () => {
	assertInInjectionContext(injectToast);
	return inject(NotificationStackService) as InjectToast;
};
